import React from 'react';

export const EditorialResourceContext = React.createContext([]);

export function useEditorialResources() {
  return React.useContext(EditorialResourceContext);
}
